import { FadeIn } from "../Animation/FadeIn";
import { NavBar } from "../Nav/NavBar";
import { AccessToCommunity } from "./AccessToCommunity";
import { CommunityTools } from "./CommunityTools";
import { Faq } from "./Faq";
import { FoundedByYou } from "./FoundedByYou";
import { InitativePeople } from "./InitativePeople";
import { LuanchApp } from "./LuachApp";
import { MultiChain } from "./MultiChain";

export const HomePage = () => {
  return (
    <div>
      <NavBar />
      <LuanchApp />
      <FadeIn>
        <CommunityTools />
      </FadeIn>

      <FadeIn>
        <AccessToCommunity />
      </FadeIn>
      <MultiChain />
      <FoundedByYou />
      <InitativePeople />

      <div className="bg-blue">
        <Faq />
      </div>
    </div>
  );
};
